import {z} from 'zod';

import {RegisterVehicleForSaleV2RequestBodySchema} from '@dms/api/vehicle';

import {BaseVehicleValidationSchema} from './BaseVehicleValidationSchema';

export const SaleVehicleValidationSchema = BaseVehicleValidationSchema.extend(
  RegisterVehicleForSaleV2RequestBodySchema.shape
).extend({
  targetAlbum: z.array(RegisterVehicleForSaleV2RequestBodySchema.shape.targetAlbum).optional(),
  photos: z
    .array(
      z.object({
        fileId: z.string(),
        fileUri: z.string(),
      })
    )
    .optional(),
});

export type SaleVehicleValidationSchemaType = z.infer<typeof SaleVehicleValidationSchema>;
